import React from "react";
import {RankConfiguration} from "./configuration/rank-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const RankStepPanelTabs = {
    configuration: RankConfiguration,
    preview: PreviewTab,
};
